<template>
  <div class="settings">
    <!-- Content -->
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <h4 class="mb-0">
              Configurações
            </h4>
          </CCardHeader>

          <CCardBody>
            <CTabs
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-2 pr-md-3 mt-3"
              add-tabs-wrapper-classes="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-10 mt-3"
            >
              <CTab :class="{ 'mb-3' : vertical }">
                <template slot="title">
                  <CIcon name="cil-window-maximize" />
                  <span>Website</span>
                </template>
                <Website />
              </CTab>

              <CTab :class="{ 'mb-3' : vertical }">
                <template slot="title">
                  <CIcon name="cil-av-timer" />
                  <span>Cookies</span>
                </template>
                <CookiesTab />
              </CTab>
              <CTab :class="{ 'mb-3' : vertical }">
                <template slot="title">
                  <CIcon name="cil-lock-locked" />
                  <span>Políticas de Privacidade</span>
                </template>
                <PrivatePolicy />
              </CTab>

              <CTab :class="{ 'mb-3' : vertical }">
                <template slot="title">
                  <CIcon name="cil-layers" />
                  <span>Termos de Uso</span>
                </template>
                <TermsOfUse />
              </CTab>

              <CTab :class="{ 'mb-3' : vertical }">
                <template slot="title">
                  <CIcon name="cil-image" />
                  <span>CMS</span>
                </template>
                <Cms />
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Website from '@/pages/settings/Website'
import CookiesTab from '@/pages/settings/Cookies'
import PrivatePolicy from '@/pages/settings/PrivatePolicy'
import TermsOfUse from '@/pages/settings/TermsOfUse'
import Cms from '@/pages/settings/Cms'
import Cookies from 'js-cookie'

export default {
  metaInfo: {
    title: 'Settings',
    titleTemplate: ' %s - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_settings')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    Website,
    CookiesTab,
    PrivatePolicy,
    TermsOfUse,
    Cms
  },

  data() {
    return {
      vertical: true,
      variant: 'pills',
      user: {}
    }
  },

  created() {
    const user = Cookies.getJSON('user')
    this.user = user
  }
}
</script>

<style lang="scss">
.settings {
  .nav {
    .envelope-icon {
      margin-top: -5px;
    }

    &.nav-tabs {
      .nav-link {
        color: $gray-700;

        &.active {
          background: none;
          border-color: $gray-200;
          color: $primary;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .card {
      .card-body {
        .nav-link {
          padding-left: 0.5rem;
          padding-right: 0.5rem;
        }
      }
    }
  }
}
</style>
